var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-overlay',{attrs:{"show":_vm.isLoading}},[(_vm.isImage)?_c('div',{staticClass:"avatar-lg img-thumbnail",style:({
      backgroundImage: ("url(" + _vm.previewUrl + ")"),
      backgroundSize: 'cover'
    })},[_vm._v("   ")]):_c('div',{staticClass:"avatar-lg d-flex align-items-center justify-content-center fa-2x text-secondary border bg-light"},[_c('g-file-icon',{attrs:{"content-type":_vm.file.type}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }